exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/layout/dashboard/dashboard.component.css
// module id = ../../../../../src/app/layout/dashboard/dashboard.component.css
// module chunks = main